// account-data.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AppLocalStorage } from '../utils/local-storage.util';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  canActivate(): Observable<boolean> {

    return timer(0, 500).pipe( // poll every 100ms
      map(() => AppLocalStorage.get('PROFILE_DATA', 'PROFILE_DATA')),
      filter(data => !!data),   // wait until data exists
      take(1),
      map(() => true)
    );
  }
}
